import React from "react";
import { Blog } from "pages/rootpage/Blog";
import { Vacancies } from "pages/rootpage/Vacancies";
import { Contact } from "pages/rootpage/Contact";
import { Login } from "pages/Login";
import { Team } from "pages/rootpage/Team"
import { StudentProfile } from "pages/ProfileUser/StudentProfile";
import StudentMatches from "./pages/StudentMatches";
import { ProfileUserView } from "pages/ProfileUser/ProfileUserView";
import { StudentRooms } from "pages/StudentRooms";

import {
  BECOMEHOST_ROUTE,
  BLOG_ROUTE,
  VACANCIES_ROUTE,
  FAQ_ROUTE,
  CONTACT_ROUTE,
  FINDROOM_ROUTE,
  LOGIN_ROUTE,
  REGISTER_ROUTE,
  HOME_ROUTE,
  STUDENT_PROFILEVIEW_ROUTE,
  STUDENT_PROFILE_ROUTE,
  STUDENT_ROOMS_ROUTE,
  STUDENT_ROOMINFO_ROUTE,
  STUDENT_MATCHES_ROUTE,
  STUDENT_CHATS_ROUTE,
  HOST_PROFILEVIEW_ROUTE,
  HOST_PROFILE_ROUTE,
  HOST_ROOMS_ROUTE,
  HOST_ROOMADD_ROUTE,
  HOST_ROOMEDIT_ROUTE,
  HOST_MATCHES_ROUTE,
  HOST_CHATS_ROUTE,
  HOST_TENANTS_ROUTE,
  STUDENT_PROFILEEDIT_ROUTE,
  HOST_PROFILEEDIT_ROUTE,
  LOGIN_EDIT,
  PRIVACY_ROUTE,
  COOKIES_ROUTE,
  CONTACTDETAILS_ROUTE,
  TEAM_ROUTE,
  PRESS_ROUTE,
  MISSION_ROUTE,
  PARTNERS_ROUTE
} from "./utils/constants";
import { HostProfile } from "pages/ProfileUser/HostProfile";
import { HostRooms } from "pages/HostRooms";
import { HostMatches } from "pages/HostMatches";
import { ProfileUserEdit } from "pages/ProfileUserEdit";
import { ChangePassword } from "pages/ChangePassword";
import { HostHouseRegistration } from "pages/HostHouseRegistration";
import { DetailedRoomInfo } from "pages/DetailedRoomInfo";
import { ChatPage } from "pages/ChatPage";
import { MyTenants } from "./pages/MyTenants";
import { PostBlog } from "pages/rootpage/Blog/CardBlog";
import { PostVacancies } from "pages/rootpage/Vacancies/CardVacancies";
import { Faq } from "pages/rootpage/Faq";
import { Privacy } from "pages/rootpage/Privacy";
import { Cookies } from "pages/rootpage/Cookies";
import { HomePage } from "./landing-components/HomePage";
import { UserMainPage } from "./pages/UserMainPage";
import { ContactDetails } from "pages/rootpage/ContactDetails";
import { Press } from "./pages/rootpage/Press";
import { Mission } from "./pages/rootpage/Mission";
import { Partners } from "pages/rootpage/Partners";
import { Route } from "react-router-dom";
import { Routes } from "react-router-dom";

export interface IRoute {
  readonly path: string;
  component: any;
  keyLocalize: string;
}

export const publicRoutes: IRoute[] = [
  {
    path: FINDROOM_ROUTE,
    component: <UserMainPage />,
    keyLocalize: "findroom",
  },
  {
    path: BECOMEHOST_ROUTE,
    component: <UserMainPage />,
    keyLocalize: "becomehost",
  },
  {
    path: CONTACT_ROUTE,
    component: <Contact />,
    keyLocalize: "contact"
  },
  {
    path: FAQ_ROUTE,
    component: <Faq />,
    keyLocalize: "faq"
  },
  {
    path: BLOG_ROUTE,
    component: <Blog />,
    keyLocalize: "blog"
  },
];

export const publicRoutesHospi: IRoute[] = [
  { path: LOGIN_ROUTE, component: <Login />, keyLocalize: "login" },
  { path: REGISTER_ROUTE, component: <Login />, keyLocalize: "register" },
  {
    path: HOME_ROUTE,
    component: <HomePage />,
    keyLocalize: "register",
  },
  { path: LOGIN_EDIT, component: <ChangePassword />, keyLocalize: "login" },
  {
    path: BLOG_ROUTE + "/:id",
    component: <PostBlog />,
    keyLocalize: "blog",
  },
  {
    path: TEAM_ROUTE,
    component: <Team />,
    keyLocalize: "team",
  },
  {
    path: PARTNERS_ROUTE,
    component: <Partners />,
    keyLocalize: "partners",
  },
  {
    path: PRESS_ROUTE,
    component: <Press />,
    keyLocalize: "press",
  },
  {
    path: MISSION_ROUTE,
    component: <Mission />,
    keyLocalize: "mission",
  },
  {
    path: VACANCIES_ROUTE,
    component: <Vacancies />,
    keyLocalize: "vacancies",
  },
  {
    path: VACANCIES_ROUTE + "/:id",
    component: <PostVacancies />,
    keyLocalize: "vacancies",
  },
  {
    path: PRIVACY_ROUTE,
    component: <Privacy />,
    keyLocalize: "privacy",
  },
  {
    path: COOKIES_ROUTE,
    component: <Cookies />,
    keyLocalize: "cookies",
  },
  {
    path: CONTACTDETAILS_ROUTE,
    component: <ContactDetails />,
    keyLocalize: "contactdetails",
  },
];

export const studentRoutes: IRoute[] = [
  {
    path: STUDENT_PROFILEVIEW_ROUTE,
    component: <ProfileUserView />,
    keyLocalize: "profile",
  },
  {
    path: STUDENT_PROFILE_ROUTE,
    component: <StudentProfile />,
    keyLocalize: "profile",
  },
  {
    path: STUDENT_PROFILEEDIT_ROUTE,
    component: <ProfileUserEdit />,
    keyLocalize: "profile",
  },
  { path: STUDENT_ROOMS_ROUTE, component: <StudentRooms />, keyLocalize: "rooms" },
  {
    path: STUDENT_ROOMINFO_ROUTE + "/:id",
    component: <DetailedRoomInfo />,
    keyLocalize: "rooms",
  },
  { path: STUDENT_CHATS_ROUTE, component: <ChatPage />, keyLocalize: "chats" },
  {
    path: STUDENT_CHATS_ROUTE + "/:user_id/:house_id",
    component: <ChatPage />,
    keyLocalize: "chats",
  },
  {
    path: STUDENT_MATCHES_ROUTE,
    component: <StudentMatches />,
    keyLocalize: "matches",
  },
];

export const hostRoutes: IRoute[] = [
  {
    path: HOST_PROFILEVIEW_ROUTE,
    component: <ProfileUserView />,
    keyLocalize: "profile",
  },
  { path: HOST_PROFILE_ROUTE, component: <HostProfile />, keyLocalize: "profile" },
  {
    path: HOST_PROFILEEDIT_ROUTE,
    component: <ProfileUserEdit />,
    keyLocalize: "profile",
  },
  { path: HOST_ROOMS_ROUTE, component: <HostRooms />, keyLocalize: "rooms" },
  {
    path: HOST_ROOMADD_ROUTE,
    component: <HostHouseRegistration />,
    keyLocalize: "roomsDetails",
  },
  {
    path: HOST_ROOMEDIT_ROUTE + "/:id",
    component: <HostHouseRegistration />,
    keyLocalize: "roomsDetails",
  },
  {
    path: STUDENT_ROOMINFO_ROUTE + "/:id",
    component: <DetailedRoomInfo />,
    keyLocalize: "rooms",
  },
  { path: HOST_MATCHES_ROUTE, component: <HostMatches />, keyLocalize: "matches" },
  {
    path: HOST_CHATS_ROUTE,
    component: <ChatPage />,
    keyLocalize: "chats",
  },
  {
    path: HOST_CHATS_ROUTE + "/:user_id/:house_id",
    component: <ChatPage />,
    keyLocalize: "chats",
  },
  { path: HOST_TENANTS_ROUTE, component: <MyTenants />, keyLocalize: "tenants" },
];
